import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { VhQueryAutoWeb, VhAlgorithm } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'atw-menu-product',
  templateUrl: './menu-product.component.html',
  styleUrls: ['./menu-product.component.scss'],
})
export class MenuProductAdminComponent implements OnInit {
  @Input() data;
  subs: any = []
  public productList: any[];
  public showProduct: any = []
  public pageCurrent: any = 1;
  public totalPages: any = 1;
  public limit: any = 10; // giới hạn sản phẩm trên 1 trang
  public listNumbersPage: any[] = [];
  public listChooseItem: any = [10, 20, 50, 100, 500]
  public searchNameProduct: any = "";
  // Pagination variables -------------
  public pageShowChoose: any = [1, 2, 3]          /** Số trang hiển thị = */
  public pageGoto: any = 1;                     /** Trang người dùng chuyển tới hiển thị = */

  constructor(
    public vhAlgorithm: VhAlgorithm,
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    public mess : NzMessageService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    // this.routeActiva.params.subscribe((params) => {
    //   this.pageCurrent = Number(params.page ? params.page : this.pageCurrent);
    //   this.getProducts(this.pageCurrent);
    // })
    this.getProducts()
  }
  trackByFn(index: number, item: any) {
    return item.id; // hoặc sử dụng một thuộc tính duy nhất khác của item
  }
  tableHeight: string;
  ngAfterViewChecked() {
  
    this.changeDetectorRef.detectChanges();
  }

  /** Hàm thực hiện lấy danh sách sản phẩm
   *
   */
  getProducts(pageCurrent?) {
    const query = JSON.parse('{"webapp_hidden": {"$eq": 1}}')
    this.vhQueryAutoWeb.getProducts_byFields(query, {}, {}, this.limit)
      .then((response: any) => {
        let products = response.data;
        this.productList = products;
        this.showProduct = this.productList;
        this.totalPages = response.totalpages;
      })
  }

  changeUnits(value: any) {
    let priceDefault = value.find(item => item.default == true)
    return priceDefault
  }
  /** Cập nhật ẩn / hiển thị item
   * @param id : id sản phẩm 
   * @param value : giá trị true false
   */
  updateShowWeb(id, value) {
    let data = JSON.parse('{"' + this.data._id + '_hidden":' + value + '}');
    this.vhQueryAutoWeb.updateProduct(id, data)
      .then((bool) => {
        
        this.mess.success('Cập nhật thành công.')
        
        if (!bool) {
          this.mess.error( 'Cập nhật không thành công ! Vui lòng thử lại.')
           
        }
      }).catch((err) => {
        this.mess.error( 'Cập nhật không thành công ! Vui lòng thử lại.')
      });
  }
  /** Chuyển trang -----------------
  *
  * @param value
  */
  transferFn(value: number): void {
    this.pageCurrent = Number(value);
    this.pageGoto = Number(value);
    if (this.searchNameProduct == '')
      this.router.navigate([], {
        queryParams: { page: this.pageCurrent },
      });
    else this.onSearchProduct(this.pageCurrent);
    // Thay đổi giá trị trang cho người dùng chọn
    if (this.pageCurrent < this.totalPages && this.pageCurrent > 1) {
      if (
        this.pageShowChoose[this.pageShowChoose.length - 1] == this.pageCurrent
      )
        this.pageShowChoose = this.pageShowChoose.map((num) => num + 1);
      else if (this.pageShowChoose[0] == this.pageCurrent)
        this.pageShowChoose = this.pageShowChoose.map((num) => num - 1);
    }
  }
  /** Chuyển trang đến trang trước
   *
   */
  gotoPreviousPage() {
    if (this.pageCurrent > 1) {
      this.transferFn(this.pageCurrent - 1);
    } else if (this.pageCurrent == 1) {
      this.transferFn(this.totalPages);
    }
  }

  /** Chuyển trang đến trang sau
   *
   */
  gotoNextPage() {
    if (this.pageCurrent < this.totalPages) {
      this.transferFn(this.pageCurrent + 1);
    } else if ((this.pageCurrent = this.totalPages)) {
      this.transferFn(1);
    }
  }
  public checkKey(event) {
    if (event.keyCode == 13) {
      this.onSearchProduct(1);
    }
  }
  /** Tìm kiếm sản phẩm
   * @param pageCurrent 
   */
  onSearchProduct(pageCurrent): void {
     
  }
}
